import React from "react";
import {
  Paper,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Tabs,
  Tab
} from "@mui/material";
import InventoryIcon from '@mui/icons-material/Inventory';
import FilterListIcon from '@mui/icons-material/FilterList';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';

export default function MetricsHeader({
  periodoSelecionado,
  handlePeriodoChange,
  canalSelecionado,
  handleCanalChange,
  canais,
  lastSync,
  onRefresh,
  isLoading,
  activeTab,
  handleTabChange
}) {
  return (
    <Paper elevation={0} sx={{ borderRadius: 2, overflow: 'hidden', background: 'linear-gradient(to right, #fff, #fff8f0)', border: '1px solid #e0e0e0' }}>      {/* Cabeçalho principal */}
      <Box sx={{ p: 3, display: "flex", flexDirection: { xs: 'column', md: 'row' }, justifyContent: "space-between", alignItems: 'center', gap: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              bgcolor: '#ff9800',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <InventoryIcon sx={{ fontSize: '1.8rem', color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#424242', mb: 0.5 }}>
              Dashboard de Métricas
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Acompanhe o desempenho dos seus produtos
            </Typography>
            {lastSync && lastSync !== '-' && (
              <Typography variant="caption" sx={{ display: 'block', color: '#f57c00', mt: 0.5 }}>
                Última sincronização: {lastSync}
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 160, background: '#fff', borderRadius: 1 }} size="small">
          <InputLabel id="canal-select-label">Canal</InputLabel>
          <Select
            labelId="canal-select-label"
            id="canal-select"
            value={canalSelecionado}
            label="Canal"
            onChange={handleCanalChange}
          >
            {canais.map((canal) => (
              <MenuItem key={canal.value} value={canal.value}>{canal.label}</MenuItem>
            ))}
          </Select>
        </FormControl>        <FormControl sx={{ minWidth: 160, background: '#fff', borderRadius: 1 }} size="small">
          <InputLabel id="periodo-select-label">Período</InputLabel>
          <Select
            labelId="periodo-select-label"
            id="periodo-select"
            value={periodoSelecionado}
            label="Período"
            onChange={handlePeriodoChange}
          >
            <MenuItem value="7dias">Últimos 7 dias</MenuItem>
            <MenuItem value="30dias">Últimos 30 dias</MenuItem>
            <MenuItem value="90dias">Últimos 90 dias</MenuItem>
            <MenuItem value="365dias">Último ano</MenuItem>
          </Select>
        </FormControl>
          <Button 
          variant="contained" 
          color="primary" 
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <FilterListIcon />}
          onClick={onRefresh}
          disabled={isLoading}
          sx={{ 
            height: 40,
            backgroundColor: '#ff9800',
            '&:hover': {
              backgroundColor: '#f57c00',
            },
          }}
        >
          {isLoading ? 'Atualizando...' : 'Filtrar'}
        </Button>
        </Box>
      </Box>
      
      {/* Navegação das abas */}
      <Box sx={{ px: 3, bgcolor: '#fff' }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange} 
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#ff9800',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '0.95rem',
              fontWeight: 500,
              '&.Mui-selected': {
                color: '#ff9800',
                fontWeight: 600
              },
              display: 'flex',
              gap: 1
            }
          }}
        >
          <Tab icon={<InventoryIcon fontSize="small" />} iconPosition="start" label="Visão Geral" />
          <Tab icon={<ShowChartIcon fontSize="small" />} iconPosition="start" label="Vendas e Desempenho" />
          <Tab icon={<AttachMoneyIcon fontSize="small" />} iconPosition="start" label="Preços e Receita" />
          <Tab icon={<LocalShippingIcon fontSize="small" />} iconPosition="start" label="Pedidos e Entregas" />
          <Tab icon={<CategoryIcon fontSize="small" />} iconPosition="start" label="Categorias e Marcas" />
          <Tab icon={<PublicIcon fontSize="small" />} iconPosition="start" label="Geografia de Vendas" />
        </Tabs>
      </Box>
    </Paper>
  );
}
